/**
 * SND-17470 — mobile / tablet search modal: bind the shared panel behaviour
 * (recent searches, best-match add to cart) to the theme's predictive-search
 * component inside #search-modal. Results/markup already come from
 * sections/snd-search-panel*.liquid (data-section-id on the component).
 */
const host = document.querySelector('#search-modal predictive-search-component[data-snd-panel]');

if (host instanceof HTMLElement && host.dataset.sndPanelJs) {
  const input = host.querySelector('input.search-input');
  const results = host.querySelector('[ref="predictiveSearchResults"]');

  if (input instanceof HTMLInputElement && results) {
    import(host.dataset.sndPanelJs)
      .then(({ setupPanel }) =>
        setupPanel({
          root: host,
          input,
          results,
          onAdded: () => {
            const dialog = host.closest('dialog-component');
            if (dialog && typeof dialog.closeDialog === 'function') dialog.closeDialog();
          },
        })
      )
      .catch((error) => console.warn('[snd-search-modal] panel module', error));
  }
}
